import React, { useState } from 'react'
import ImageCarousel from './component'
import ContentEntryDataGetter from 'layers/content/Hocs/ContentEntryDataGetter'
import PropTypes from 'prop-types'

export const ImageCarouselContainer = ({ contentfulLesson }) => {
  let [currentSlide, setCurrentSlide] = useState(0)

  return (
    <ImageCarousel
      contentfulLesson={contentfulLesson}
      currentSlide={currentSlide}
      setCurrentSlide={setCurrentSlide}
    />
  )
}

export const mapper = entry => {
  return { contentfulLesson: entry }
}

const options = {
  include: 2,
  mapper,
  spread: true,
  entryIdProp: true,
}

ImageCarouselContainer.propTypes = {
  contentfulLesson: PropTypes.shape({
    displayTitle: PropTypes.string.isRequired,
    content: PropTypes.array.isRequired,
  }),
}

export default ContentEntryDataGetter(ImageCarouselContainer, options)
